import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { CaslSubject } from '../../../shared/modules/authz/decorators/casl-subject.decorator';
import { BaseDto } from '../../../shared/modules/base/dtos/base.dto';
import { UserListDto } from '../../../shared/modules/users/dtos/user-list.dto';
import { FileboxOperationEnum } from '../enums/filebox-operation.enum';
import { FileboxStatusEnum } from '../enums/filebox-status.enum';

/**
 * Filebox DTO for lists
 */
@CaslSubject(AppSubjectEnum.FILEBOX)
export class FileboxListDto extends BaseDto {
	tenantId!: number;
	user!: UserListDto;
	status!: FileboxStatusEnum;
	operation!: FileboxOperationEnum;
	key!: string;
	fileUuid!: string;
	synchronizationToken!: string;
	retryCount!: number;
	nextRetryAt?: Date;
	leasedBy?: string;
	leasedUntil?: Date;
	synchronizedAt?: Date;
	synchronizationError?: string;

	mobileTitle = (): string | null => {
		return null;
	};

	mobileSubtitle = (): string | null => {
		return null;
	};
}
